interface TradeTypeCardProps {
  type: 'buy' | 'sell' | 'exchange'
  isActive: boolean
  onClick: () => void
}

const LABELS: Record<TradeTypeCardProps['type'], string> = {
  buy: '매입',
  sell: '매각',
  exchange: '교환',
}

const ACTIVE_CLASSES: Record<TradeTypeCardProps['type'], string> = {
  buy: 'bg-fx-buy text-white',
  sell: 'bg-fx-sell text-white',
  exchange: 'bg-violet-500 text-white',
}

function TradeTypeCard({ type, isActive, onClick }: TradeTypeCardProps) {
  return (
    <button
      onClick={onClick}
      className={`
        flex-1 h-16 rounded-lg px-8 transition-all
        ${isActive ? ACTIVE_CLASSES[type] : 'bg-fx-card-inactive text-fx-text-muted'}
      `}
    >
      <div className="flex items-center justify-center gap-4">
        <span className="text-2xl font-bold">
          {LABELS[type]}
        </span>
      </div>
    </button>
  )
}

export default TradeTypeCard
